// Wait until the entire HTML document is loaded and parsed.
document.addEventListener('DOMContentLoaded', () => {
  // --- Scroll to Top Button ---
  const scrollToTopBtn = document.getElementById('scroll-to-top')
  if (scrollToTopBtn) {
    window.addEventListener('scroll', () => {
      // Show button if user has scrolled down more than 400px
      if (window.scrollY > 400) {
        scrollToTopBtn.classList.remove('hidden')
      } else {
        scrollToTopBtn.classList.add('hidden')
      }
    })

    scrollToTopBtn.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    })
  }

  // --- Hero Swiper ---
  const heroSwiperEl = document.querySelector('.hero-swiper')
  if (heroSwiperEl) {
    new Swiper(heroSwiperEl, {
      loop: true,
      effect: 'slide',
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  }

  // --- Artifact Carousels Initialization ---
  const artifactSections = document.querySelectorAll('.artifact-grid-section')


  artifactSections.forEach((section) => {
  const swiperEl = section.querySelector('.artifacts-grid-swiper')
  const nextBtn = section.querySelector('.carousel-next')
  const prevBtn = section.querySelector('.carousel-prev')

  if (swiperEl && nextBtn && prevBtn) {
    const slides = swiperEl.querySelectorAll('.swiper-slide')

    if (slides.length === 1) {
      swiperEl.classList.add('single-slide')
      // Nếu chỉ có 1 item -> căn giữa luôn, không cần loop
      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: false,
      })
      // Ẩn nút prev/next nếu muốn
      nextBtn.style.display = 'none'
      prevBtn.style.display = 'none'
    } else {
      // Bình thường
      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      })
    }
  }
})


  // --- Hero Slider ---
  const heroSlider = document.getElementById('hero-slider')
  if (heroSlider) {
    const slides = heroSlider.querySelectorAll('.hero-slide')
    const controlsContainer = document.getElementById('slider-controls')
    let currentSlide = 0

    if (slides.length > 1 && controlsContainer) {
      // Create control dots
      slides.forEach((_, index) => {
        const dot = document.createElement('button')
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`)
        dot.classList.add('w-3', 'h-3', 'rounded-full', 'transition-all', 'duration-300')
        dot.classList.add(index === 0 ? 'bg-white' : 'bg-white/50', index === 0 ? 'scale-125' : 'scale-100')
        dot.addEventListener('click', () => showSlide(index))
        controlsContainer.appendChild(dot)
      })

      const dots = controlsContainer.querySelectorAll('button')

      const showSlide = (index) => {
        slides.forEach((slide, i) => {
          slide.classList.toggle('opacity-100', i === index)
          slide.classList.toggle('scale-100', i === index)
          slide.classList.toggle('opacity-0', i !== index)
          slide.classList.toggle('scale-105', i !== index)
        })
        dots.forEach((dot, i) => {
          dot.classList.toggle('bg-white', i === index)
          dot.classList.toggle('scale-125', i === index)
          dot.classList.toggle('bg-white/50', i !== index)
          dot.classList.toggle('scale-100', i !== index)
        })
        currentSlide = index
      }

      const nextSlide = () => {
        const newIndex = (currentSlide + 1) % slides.length
        showSlide(newIndex)
      }

      setInterval(nextSlide, 6000) // Auto-slide every 6 seconds
    }
  }

  // --- Collection Filtering ---
  const collectionFilters = document.getElementById('collection-filters')
  const collectionItems = document.querySelectorAll('.collection-item')
  if (collectionFilters && collectionItems.length > 0) {
    collectionFilters.addEventListener('click', (e) => {
      if (e.target.matches('.filter-button')) {
        const filterButtons = collectionFilters.querySelectorAll('.filter-button')
        filterButtons.forEach((btn) => {
          btn.classList.remove('bg-red-600', 'text-white')
          btn.classList.add('bg-gray-100', 'text-gray-700')
        })
        e.target.classList.add('bg-red-600', 'text-white')
        e.target.classList.remove('bg-gray-100', 'text-gray-700')

        const filterValue = e.target.getAttribute('data-filter')
        collectionItems.forEach((item) => {
          if (filterValue === 'all' || item.getAttribute('data-category') === filterValue) {
            item.classList.remove('hidden')
          } else {
            item.classList.add('hidden')
          }
        })
      }
    })
  }

  // --- Collection Item Modal ---
  const collectionGrid = document.getElementById('collection-grid')
  const modal = document.getElementById('collection-item-modal')
  if (collectionGrid && modal) {
    const modalCloseButton = document.getElementById('modal-close-button')
    const modalContent = document.getElementById('modal-content-area')

    collectionGrid.addEventListener('click', (e) => {
      const item = e.target.closest('.collection-item')
      if (item) {
        // Populate modal
        document.getElementById('modal-image').src = item.dataset.image
        document.getElementById('modal-image').alt = item.dataset.name
        document.getElementById('modal-name').textContent = item.dataset.name
        document.getElementById('modal-period').textContent = item.dataset.period
        document.getElementById('modal-origin').textContent = item.dataset.origin
        document.getElementById('modal-material').textContent = item.dataset.material
        document.getElementById('modal-fullDescription').textContent = item.dataset.fulldescription

        // Show modal
        modal.classList.remove('hidden')
      }
    })

    const closeModal = () => modal.classList.add('hidden')
    modalCloseButton.addEventListener('click', closeModal)
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        // Close only if clicking the backdrop
        closeModal()
      }
    })
  }

  // --- Exhibition Filtering ---
  const exhibitionTabs = document.getElementById('exhibition-tabs')
  const exhibitionList = document.querySelectorAll('.exhibition-item')
  if (exhibitionTabs && exhibitionList.length > 0) {
    exhibitionTabs.addEventListener('click', (e) => {
      if (e.target.matches('.exhibition-tab-button')) {
        const tabButtons = exhibitionTabs.querySelectorAll('.exhibition-tab-button')
        tabButtons.forEach((btn) => {
          btn.classList.remove('bg-white', 'text-red-600', 'shadow-md')
          btn.classList.add('text-gray-600')
        })
        e.target.classList.add('bg-white', 'text-red-600', 'shadow-md')
        e.target.classList.remove('text-gray-600')

        const tabValue = e.target.getAttribute('data-tab')
        exhibitionList.forEach((item) => {
          if (item.getAttribute('data-type') === tabValue) {
            item.classList.remove('hidden')
          } else {
            item.classList.add('hidden')
          }
        })
      }
    })
    // Trigger a click on the first tab to show initial content
    exhibitionTabs.querySelector('.exhibition-tab-button').click()
  }

  // --- Contact Success Modal ---
  const successModal = document.getElementById('success-modal')
  if (successModal) {
    const closeButton = document.getElementById('success-modal-close-button')
    const closeModal = () => successModal.classList.add('hidden')

    closeButton.addEventListener('click', closeModal)
    successModal.addEventListener('click', (e) => {
      if (e.target === successModal) {
        // Close if clicking backdrop
        closeModal()
      }
    })
  }
})
